import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

export const Layout = styled.div`
    display: block;
    background-color: ${Variables.Colors.ghostWhite};
    padding: 48px;
`;
